import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { LOCAL_STORAGE_NAME } from 'src/utils/constants';
import { auth } from 'src/utils/helper';
import {
  getItem,
  removeItem,
} from 'src/utils/localStorage';

export const PublicRoute = ({
  component,
  ...rest
}: any) => {
  return (
    <Route
      {...rest}
      render={props => {
        if (!auth()) {
          return (
            <Route
              {...rest}
              render={React.createElement(component, props)}
            />
          );
        } else {
          const url_redirect = getItem(
            LOCAL_STORAGE_NAME.URL_REDIRECT,
          );
          removeItem(LOCAL_STORAGE_NAME.URL_REDIRECT);
          return (
            <Redirect
              to={{
                pathname: url_redirect || '/',
              }}
            />
          );
        }
      }}
    />
  );
};
